import { render, staticRenderFns } from "./GlobalChooseInvestor.vue?vue&type=template&id=661f905c&scoped=true"
import script from "./GlobalChooseInvestor.vue?vue&type=script&lang=js"
export * from "./GlobalChooseInvestor.vue?vue&type=script&lang=js"
import style0 from "./GlobalChooseInvestor.vue?vue&type=style&index=0&id=661f905c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661f905c",
  null
  
)

export default component.exports